import { render, staticRenderFns } from "./allocation.vue?vue&type=template&id=13c8dd5c&scoped=true"
import script from "./allocation.vue?vue&type=script&lang=js"
export * from "./allocation.vue?vue&type=script&lang=js"
import style0 from "./allocation.vue?vue&type=style&index=0&id=13c8dd5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c8dd5c",
  null
  
)

export default component.exports